/**
 * The one fetch wrapper. A 401 from any call is heard once, by the session
 * provider, which shows the sign-in screen.
 */
export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
    credentials: 'same-origin',
  })
  if (res.status === 401) window.dispatchEvent(new Event('session:ended'))
  if (!res.ok) {
    let message = res.statusText
    try { message = (await res.json()).error || message } catch { /* body was not JSON */ }
    throw new ApiError(res.status, message)
  }
  return res.json() as Promise<T>
}

export const post = <T,>(path: string, body: unknown) => api<T>(path, { method: 'POST', body: JSON.stringify(body) })
export const patch = <T,>(path: string, body: unknown) => api<T>(path, { method: 'PATCH', body: JSON.stringify(body) })
export const put = <T,>(path: string, body: unknown) => api<T>(path, { method: 'PUT', body: JSON.stringify(body) })
export const del = <T,>(path: string) => api<T>(path, { method: 'DELETE' })
